jQuery(document).ready(function($) {

	document.addEventListener( 'wpcf7mailsent', function(event) {
		if ('100' == event.detail.contactFormId) {
	    	$('.contact-split__form-wrapper').hide();
	    	$('.contact-split__form-success').show();
	  	}
	}, false );

	$('.styled-select select').change(function() {
		$(this).removeClass('inactive');
	});
	
    var slug = window.location.pathname.substring(1);
    console.log( window.location.pathname.substring(1));
    if(slug == 'contact/') {
        if($(document).width() > '768' ) {
            $('.bg--light').css('background-color', '#ffffff');
            $('.bg--light').css('padding-top', '100px');
            $('#header .btn--orange').addClass('contact-page');
        }
        if($(document).width() < '768' ) {
            $('.bg--blue').css('padding-top', '12rem');
            $('#header .btn--orange').addClass('contact-page');
            $('.bg--light').css('background-color', '#ffffff');
        }
    }

});